import { overtime } from "../_constants/actionConstants";

const otInitialState = {
  overtimeList: {}, // Normalized by tabId
  fetching: false,
};

export const reducer = (state = otInitialState, action) => {
  switch (action.type) {
    case overtime.REQUEST_OVERTIME:
    case overtime.FETCH_USER_OVERTIMES:
    case overtime.EDIT_OVERTIME:
      return { ...state, fetching: true };

    case overtime.REQUEST_OVERTIME_FULFILLED:
    case overtime.FETCH_USER_OVERTIMES_FULFILLED:
    case overtime.EDIT_OVERTIME_FULFILLED:
      if (!action.tabId) return { ...state, fetching: false };
      return {
        ...state,
        overtimeList: {
          ...state.overtimeList,
          [action.tabId]: action.overtimeList,
        },
        fetching: false,
      };

    case overtime.REQUEST_OVERTIME_REJECTED:
    case overtime.FETCH_USER_OVERTIMES_REJECTED:
    case overtime.EDIT_OVERTIME_REJECTED:
      return { ...state, fetching: false };

    default:
      return state;
  }
};
